(function($) {
	$('.content-matrix table').wrap('<div class="table-responsive"></div>');
})(jQuery);